(function () {
  'use strict';

  // Mobiles Menü
  var burger = document.getElementById('burger');
  var menu = document.getElementById('menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') { menu.classList.remove('open'); }
    });
  }

  // Reiter (Produktseite)
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('.tab');
    var panels = group.parentNode.querySelectorAll('.tab-panel');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        if (panels[i]) { panels[i].classList.add('active'); }
      });
    });
  });

  // Produktgalerie
  var galMain = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (galMain) { galMain.src = thumb.dataset.full; }
    });
  });

  // Kaufoption (Einmalkauf / Abo)
  var planInput = document.querySelector('[data-selling-plan]');
  document.querySelectorAll('[data-plan]').forEach(function (plan) {
    plan.addEventListener('click', function () {
      document.querySelectorAll('[data-plan]').forEach(function (p) { p.classList.remove('active'); });
      plan.classList.add('active');
      if (planInput) { planInput.value = plan.dataset.plan; }
    });
  });

  // Variantenauswahl
  var variantInput = document.querySelector('[data-variant-input]');
  document.querySelectorAll('[data-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-variant]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (variantInput) { variantInput.value = btn.dataset.variant; }
      var now = document.querySelector('[data-price-now]');
      var old = document.querySelector('[data-price-old]');
      if (now) { now.textContent = btn.dataset.price; }
      if (old) {
        old.textContent = btn.dataset.compare || '';
        old.style.display = btn.dataset.compare ? '' : 'none';
      }
    });
  });

  // Mengenwahl
  var qty = document.querySelector('[data-qty-input]');
  var minus = document.querySelector('[data-qty-minus]');
  var plus = document.querySelector('[data-qty-plus]');
  if (qty && minus && plus) {
    minus.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
    plus.addEventListener('click', function () { qty.value = Math.min(99, parseInt(qty.value, 10) + 1); });
  }
})();
